import { render, staticRenderFns } from "./DashboardSubHeader.vue?vue&type=template&id=06c3c564&scoped=true"
import script from "./DashboardSubHeader.vue?vue&type=script&lang=js"
export * from "./DashboardSubHeader.vue?vue&type=script&lang=js"
import style0 from "./DashboardSubHeader.vue?vue&type=style&index=0&id=06c3c564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c3c564",
  null
  
)

export default component.exports